import { frontendURL } from 'dashboard/helper/URLHelper.js';

const ProtocolsPage = () => import('./pages/ProtocolsPage.vue');
const ProtocolCategoriesPage = () =>
  import('./pages/ProtocolCategoriesPage.vue');

const meta = {
  permissions: ['administrator', 'agent'],
};

const adminMeta = {
  permissions: ['administrator'],
};

const protocolRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/protocols'),
      name: 'protocols_index',
      meta,
      component: ProtocolsPage,
    },
    {
      path: frontendURL('accounts/:accountId/protocols/categories'),
      name: 'protocol_categories',
      meta: adminMeta,
      component: ProtocolCategoriesPage,
    },
    {
      path: frontendURL('accounts/:accountId/protocols/:protocolId'),
      name: 'protocol_show',
      meta,
      component: ProtocolsPage,
      props: true,
    },
  ],
};

export default protocolRoutes;
